import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './i18n.ts';
import './styles.css';
import { StubPage } from './gm/StubPage.tsx';

/** Вид игроков — отдельный чанк без кода экрана мастера (NFR-5). */
const ViewApp = lazy(() => import('./view/ViewApp.tsx'));

function App() {
  if (window.location.pathname.startsWith('/view/')) {
    return (
      <Suspense fallback={null}>
        <ViewApp />
      </Suspense>
    );
  }
  return <StubPage />;
}

const root = document.getElementById('root');
if (!root) throw new Error('#root не найден');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
